<div class="card">
  <div class="card" style="display: flex; justify-content: space-between; align-items: center; padding: 0; border: none; background-color: transparent;">
    <div>
        <h4><strong style=" margin-left: 10px;">Goods Receipt</strong></h4>
    </div>
    <div style="display: flex; margin-top: -10px;">
        <button pButton type="button" icon="pi pi-download" (click)="onClickExcel()" style=" background-color: #2c436b;" label="Excel Report"></button>
        <!-- <button pButton type="button" icon="pi pi-download" (click)="downloadPDF()" style="height: 10px; margin-right: 10px; background-color: #2c436b;" label="PDF Report"></button> -->
    </div>
  </div>
    <hr>
    <p-treeTable #tt [value]="mappedData" styleClass="p-treetable-gridlines" [columns]="cols" [scrollable]="true" [tableStyle]="{ 'min-width': '125rem','min-height':'10px' }">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th style="width: 4rem;text-align: center; white-space: nowrap;">Action</th>
                <!-- <th>Status</th> -->
                <th>Vendor Code</th>
                <th>Status</th>
                <th>Invoice No</th>
                <th>Invoice Date</th>
                <th>PO/Agreement No</th>
                <th>GR No</th>
                <th>GR Date</th>
                <th>Gate Entry No</th>
                <th>Gate Entry Date</th>
                <th>Vendor Name</th>
                <th>Plant</th>
            </tr>
            <!-- <tr>
                <th class="text-center">PO No</th>
                <th class="text-center">Line Item No</th>
                <th class="text-center">Material Code</th>
                <th class="text-center">Description</th>
                <th class="text-center">Quantity</th>
                <th class="text-center">UOM</th>
                <th class="text-center">Vendor Batch</th>
                <th class="text-center">Storage Location</th>
                <th class="text-center">GR Quantity</th>
                <th class="text-center">GR Batch No</th>
            </tr> -->
            <tr>
                <th></th>
                <th *ngFor="let col of cols">
                  <!-- <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)"
                      [ngModel]="col.defaultFilter" /> -->
                      <ng-container *ngIf="col.field === 'gr_date' || col.field === 'invoice_date' || col.field === 'gr_batch_no'; else textInput">
                        <input pInputText type="date" (change)="onInputChange($event, col.field)" placeholder="Select date..." />
                      </ng-container>
                      <ng-template #textInput>
                        <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
                      </ng-template>
              </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="caption">
            <div class="flex justify-content-end align-items-center">
                <div class="p-input-icon-left">
                    <i class="pi pi-search" style="font-size: 12px;"></i>
                    <input type="text" class="global-search" pInputText placeholder="Global Search"
                        (input)="onGlobalSearch($event)" />
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr [ttRow]="rowNode">
                <td style="width: 4rem;justify-content: center; align-items: center;;white-space: nowrap;">
                    <p-button *ngIf="rowNode.node.children"
                        tooltipPosition="top" icon="pi pi-eye" (click)="onClickGr(rowNode)" [rounded]="true"
                        [style]="{ 'margin-right': '.5em' }"></p-button>
                </td>
                <td *ngFor="let col of columns; let i = index; let last = last">
                    <div class="row">
                        <!-- <div class="column">
                            <p-button *ngIf="i === 0 && rowNode.node.children && rowNode.node.children.length > 0"
                                tooltipPosition="top" icon="pi pi-eye" (click)="onClickGr(rowNode)" [rounded]="true"
                                [style]="{ 'margin-right': '.5em' }"></p-button> -->
                            <!-- <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler> -->
                        <!-- </div> -->
                        <!-- <div>
                            {{ rowData[col.field] }}
                        </div> -->
                        <div *ngIf="col.field === 'status'; else defaultField">
                            <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData[col.field]))">
                                {{ rowData[col.field] }}
                            </span>
                        </div>

                        <ng-template #defaultField>
                            {{ rowData[col.field] }}
                        </ng-template>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-treeTable>
    <div>
        <p-paginator
            [rows]="limit"
            [first]="(currentPage - 1) * limit"
            [totalRecords]="totalRecords"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[10, 20,30,50,100]"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
       />
    </div>
</div>
<p-sidebar [(visible)]="sidebarVisible" position="right" [style]="{'width': '70%'}">
    <div class="row">
        <div class="column">
            <h5><strong>{{"GR No : "+ grNo}}</strong></h5>
        </div>
        <div class="column">
            <div class="button-container">
                <button type="button" pButton pRipple icon="pi pi-file-excel" class="p-button-success mr-2"
                    pTooltip="XLS" tooltipPosition="bottom"
                    (click)="downloadExcel()"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" class="p-button-info mr-2" pTooltip="PDF"
                    tooltipPosition="bottom" (click)="exportPdf(selectedGrData,selectedPoData)"></button>
            </div>
        </div>
    </div> <br>
    <p-table #dt [value]="selectedGrData" styleClass="p-datatable-sm" selectionMode="multiple">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th>Vendor Code</th>
                <th>Plant</th>
                <th>GR No</th>
                <th>Vendor Name</th>
                <th>GR Date</th>
                <th>GR Time</th>
                <th>Gate Entry No</th>
                <th>Gate Entry Date</th>
                <th>Invoice No</th>
                <th>Invoice Date</th>
                <th>Status</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{rowData.vendor_code}}</td>
                <td>{{rowData.plant}}</td>
                <td>{{rowData.gr_no}}</td>
                <td>{{rowData.vendor_name}}</td>
                <td>{{rowData.gr_date}}</td>
                <td>{{rowData.gr_time}}</td>
                <td>{{rowData.gate_entry_date}}</td>
                <td>{{rowData.invoice_date}}</td>
                <td>{{rowData.gr_quantity}}</td>
                <td>{{rowData.gr_batch_no}}</td>
                <!-- <td>{{rowData.status}}</td> -->
                <td>
                    <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData.status))">
                        {{ rowData.status }}
                    </span>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <h5><strong>{{"PO No : " + poNo}}</strong></h5><br>
    <p-table #dt [value]="selectedPoData" styleClass="p-datatable-sm" selectionMode="multiple">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th>Sr.No</th>
                <th>PO No</th>
                <th>Line Item No</th>
                <th>Material Code</th>
                <th>Description</th>
                <!-- <th>Quantity</th> -->
                <th>UOM</th>
                <!-- <th>Vendor Batch</th> -->
                <th>Storage Location</th>
                <th>GR Quantity</th>
                <th>GR Batch No</th>
                <th>Gate Entry Quantity</th>
                <th>OK Quantity</th>
                <th>Reject Quantity</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td><strong>{{rowData.sr_no}}</strong></td>
                <td>{{rowData.plant}}</td>
                <td>{{rowData.gr_no}}</td>
                <td>{{rowData.vendor_code}}</td>
                <td>{{rowData.vendor_name}}</td>
                <!-- <td>{{rowData.gate_entry_no}}</td> -->
                <td>{{rowData.gr_date}}</td>
                <!-- <td>{{rowData.invoice_no}}</td> -->
                <td>{{rowData.gr_time}}</td>
                <td>{{rowData.gate_entry_date}}</td>
                <td>{{rowData.invoice_date}}</td>
                <td>{{rowData.gate_entry_quantity}}</td>
                <td>{{rowData.ok_quantity}}</td>
                <td>{{rowData.reject_quantity}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-sidebar>
<p-dialog header="Header" [closable]="false" [(visible)]="isExcel" [modal]="true" [style]="{ width: '35rem'}"
[breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
<ng-template pTemplate="header">
    <!-- <div class="inline-flex align-items-center justify-content-center gap-2">
        <span class="font-bold white-space-nowrap">Select Date</span>
    </div> -->
</ng-template>
<ng-template pTemplate="footer">
    <p-button (click)="onCloseForExcelReport()" label="Close" pAutoFocus [autofocus]="true"></p-button>
    <p-button (click)="onDowunloadGrListByDate()" label="Download" pAutoFocus [autofocus]="true"
        [disabled]="!startDate || !endDate || dateValidation"></p-button>
</ng-template>
    <div class="grid">
        <div class="col">
            <label class="font-bold block mb-2"><strong>Start Date</strong><span class="required-asterisk">*</span></label>
            <div class="p-input-icon-left">
                <p-calendar [iconDisplay]="'input'" [showIcon]="true"
                    placeholder="Select Date" [(ngModel)]="startDate" appendTo="body" dateFormat="dd/mm/yy" [maxDate]="correctDate"
                    [showButtonBar]="true" (onSelect)="validateDate()" [required]="true"></p-calendar>
                <!-- <div *ngIf="dateValidation" class="text-red-500">Please select correct date</div> -->
            </div>
        </div>
        <div class="col">
            <label class="font-bold block mb-2"><strong>End Date</strong><span class="required-asterisk">*</span></label>
            <div class="p-input-icon-left">
                <p-calendar [iconDisplay]="'input'" [showIcon]="true"
                    placeholder="Select Date" appendTo="body" [(ngModel)]="endDate" dateFormat="dd/mm/yy" [maxDate]="correctDate"
                    [showButtonBar]="true" (onSelect)="validateDate()" [required]="true"></p-calendar>
                <!-- <div *ngIf="dateValidation" class="text-red-500">Please select correct date</div> -->
                <div *ngIf="endDate && startDate && endDate < startDate" class="text-red-500">End date cannot be before start date.</div>
                <div *ngIf="dateValidation && endDate && getDateDifference() > 4" class="text-red-500">The end date cannot be more than 4 months after the start date.</div>
            </div>
        </div>
    </div>
</p-dialog>

<div *ngIf="isLoading" class="loading-overlay">
  <app-loading-screen></app-loading-screen>
</div>
<p-toast></p-toast>
